/** @module browser ブラウザの種類や状態に関するコンポーザブル関数 */
import { useMediaQuery } from "@vueuse/core";

/** モバイルかどうかの判定フラグ */
export function useMobileFlag() {
  return useMediaQuery('screen and (max-width: 599px)');
}
